import { SysDataBaseApi } from "../SysDataBaseApi";

/**
 * 示意图图库Api
 */
export class PicturelibraryApi extends SysDataBaseApi {
    public get ControllerName(): any {
        return 'Picturelibrary'
    }
}
